/*jshint esversion: 6 */
'use strict';

$(function () {

  $(document).pjax("#modal-pjax a", { "push": false, "replace": false, "timeout": 2000, "scrollTo": false, "container": "#modal-pjax" });
  $(document).off("submit", "#modal-pjax form[data-pjax]").on("submit", "#modal-pjax form[data-pjax]", function (event) { jQuery.pjax.submit(event, { "push": false, "replace": false, "timeout": 2000, "scrollTo": false, "container": "#modal-pjax" }); });

  let el, left, x;

  $('body')
    .on("click", '.sandwich', function () {
      $('body').toggleClass('menu-open');
      /*}).on('click', '.pagination a', function () {
          //$('#winners-grid').css('opacity', .4);
          $('html, body').animate({ scrollTop: $('#winners').offset().top }, 500);*/
    })
    .on('click', '[data-modal]:not([disabled])', function () {
      // document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;
      $('#modal-pjax').load($(this).data('modal'), function () {
        $('#modal-pjax').focus();
      });
      $('body').removeClass('menu-open').addClass('modal-open');
      //$('#top_menu').removeClass('hover');
    })
    .on('click', '.close', function () { // , #overlay
      $('body').removeClass('modal-open').removeClass('menu-open');
      $('#modal-pjax > *').remove();
      // mahist = document.getElementById('profile');
      // if(mahist) { $.pjax.reload({container: '#profile', async: false}); }
    })

    .on('click', '[data-scroll]', function () {
      $('body').removeClass('modal-open').removeClass('menu-open');
      let to = $(this).data('scroll');
      $('html, body').animate({ scrollTop: $(to).offset().top }, 500);
    })

    .on('submit', '#mess-form', function () {
      $('#mess-form button').prop('disabled', 'true');
    });

  //$('.page-content').mCustomScrollbar();

});
